import './lang-switcher.css';
import { changeLanguage, getLocale, t, type AppLocale } from '../i18n';

function buildSwitcherHtml(): string {
  const locale = getLocale();
  return `
    <div class="lang-switcher" role="group" aria-label="${t('lang.switchLabel')}">
      <button type="button" class="lang-switcher-btn ${locale === 'it' ? 'active' : ''}" data-lang="it">${t('lang.it')}</button>
      <span class="lang-switcher-sep">|</span>
      <button type="button" class="lang-switcher-btn ${locale === 'en' ? 'active' : ''}" data-lang="en">${t('lang.en')}</button>
    </div>
  `;
}

function bindSwitcher(root: HTMLElement): void {
  root.querySelectorAll('[data-lang]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const lang = (btn as HTMLElement).dataset.lang as AppLocale;
      if (lang) await changeLanguage(lang);
    });
  });
}

export function mountLangSwitcher(container: HTMLElement): void {
  const existing = container.querySelector('.lang-switcher');
  if (existing) existing.remove();
  container.insertAdjacentHTML('beforeend', buildSwitcherHtml());
  const el = container.querySelector('.lang-switcher');
  if (el) bindSwitcher(el as HTMLElement);
}

export function remountLangSwitcher(container: HTMLElement | null): void {
  if (container) mountLangSwitcher(container);
}
